<div class="close-button" (click)="close()"></div>
<div class="error-dialog">
    <h2 class="dialog-h2">{{ data.title }}</h2>
    <p class="dialog-text">{{ data.message }}</p>
    <p class="dialog-text">Error code: <span class="dialog-text-error">{{ data.errorCode }}</span></p>
    <button class="primary-button" (click)="close()">Close</button>
</div>